import MuiOutlinedInput, { type OutlinedInputProps } from "@mui/material/OutlinedInput";
import MuiFilledInput, { type FilledInputProps } from "@mui/material/FilledInput";

export type { OutlinedInputProps, FilledInputProps };

export function OutlinedInput(props: OutlinedInputProps) {
  return <MuiOutlinedInput {...props} />;
}
export function FilledInput(props: FilledInputProps) {
  return <MuiFilledInput {...props} />;
}
